import CreatorCard from "_components/molecules/creatorCard";

import useStyles from "./styles";

const component = ( { list = [] } ) => {
	const { classes } = useStyles ( { listLength: list.length } );

	return (
		<div className = { classes.creatorCardContainer }>
			{list.map ( ( item, idx ) => (
				<CreatorCard
					key  = { idx }
					data = { item }
				/>
			)
			) }
		</div>
	);
};

export default component;